import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { CampaignConfig } from 'schemas/CampaignConfig.schema.ts';
import { apiFetch } from 'utils/apiUtils';

interface IFetchIterationExportVariables {
  teamId: string,
  campaignId: string,
  iterationId: string,
}

export default function useFetchIterationExport({ teamId, campaignId, iterationId }: IFetchIterationExportVariables) {
  const { tokens } = useAuth();
  return useQuery({
    enabled: false,
    queryKey: ['campaign', { teamId, campaignId, iterationId }],
    queryFn: async () => apiFetch<{ config: CampaignConfig }>({
      path: `team/${teamId}/campaign/${campaignId}/iteration/${iterationId}/getConfig`,
      method: 'GET',
      accessToken: String(tokens.accessToken),
    }),
  });
}
